// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3V3cC","header":"ReportDetails_header__gEC9F","title":"ReportDetails_title__20YFU","left":"ReportDetails_left__1sN56"};